<div class="score-loading">
  <img src="assets/gifs/scanning.gif" alt="Cargando" />
  <div class="score-loading__message">
    <h3>{{ messages[currentMessageIndex].title }}</h3>
    <div>{{ messages[currentMessageIndex].description }}</div>
  </div>
</div>
